import { FC, PropsWithChildren, useEffect } from 'react';

import { useUnsavedChangesStore } from '@/shared/store/unsavedChanges.store';

export const UnsavedChangesProvider: FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!useUnsavedChangesStore.getState().hasUnsavedChanges()) return;

      event.preventDefault();
      event.returnValue = true;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return children;
};
